











import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { UserAddress } from '@unified-commerce/gpc-vue-storefront-shopify';

export default defineComponent({
  name: 'AddressBlock',
  props: {
    address: {
      type: Object as PropType<UserAddress>,
      required: true,
    },
  },
  setup(props) {
    const formattedAddressLines = computed(() => {
      if (props.address) {
        const { address1, address2, city, provinceCode, zip, country, phone } = props.address;
        return [
          address1,
          `${address2 ? `${address2},` : ''} ${city}, ${provinceCode} ${zip}`,
          country,
          phone,
        ];
      }
      return [];
    });

    const formattedName = computed(() => {
      if (props.address) {
        const { firstName, lastName, company } = props.address;
        const companyText = company ? `, ${company}` : ' ';
        return `${firstName} ${lastName}${companyText}`;
      }
      return '';
    });

    return {
      formattedAddressLines,
      formattedName,
    };
  },
});
